// extracted by css-extract-rspack-plugin
export default {"StatusCheckHeader":"RequiredStatusCheckSelectList-module__StatusCheckHeader__w0p2_"};